import { render } from "./SectionTitle.vue?vue&type=template&id=091b1992&scoped=true&ts=true"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"

import "./SectionTitle.vue?vue&type=style&index=0&id=091b1992&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091b1992"]])

export default __exports__